export default "data:image/webp;base64,UklGRiYAAABXRUJQVlA4TBkAAAAvJ8AEAIWYhqikfzkNzDluk9D/5H2Sx/sAAA=="